import React, { useState } from "react";
import { 
  Flex, 
  Button, 
  Link, 
  Text, 
  Image, 
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useBreakpointValue
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { texts } from "../../lang";
import { useLanguage } from "../../context/LanguageContext";
import { COLORS } from "../../globalvariables";

const Navbar = () => {
  const { language, toggleLanguage } = useLanguage();
  const isMobile = useBreakpointValue({ base: true, md: false });

  // Drapeaux pour les langues
  const flags = {
    en: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg/1200px-Flag_of_the_United_Kingdom_%283-5%29.svg.png",
    fr: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Flag_of_France.svg/1200px-Flag_of_France.svg.png",
  };

  return (
    <Flex
      as="nav"
      top={0}
      w="100%"
      justify={isMobile ? "center" : "space-between"}
      align="center"
      py={{ base: 3, md: 12 }}
      px={{ base: 4, md: 8 }}
      height={{ base: "60px", md: "80px" }}
      bgGradient={COLORS.headerGradient}
      color={COLORS.creamText}
      boxShadow="0 2px 10px rgba(0,0,0,0.2)"
      borderBottom={`1px solid ${COLORS.primary}`}
      position="relative"
    >
      {/* Logo à gauche */}
      <Box 
        position={isMobile ? "absolute" : "relative"} 
        left={isMobile ? "4" : "auto"}
        w={{ base: "25%", md: "15%" }}
      >
        <Link 
          href="/" 
          _hover={{ textDecoration: "none" }} 
          position="absolute"
          transform="translateY(-60%)"
        >
          <Image
            src="/logo_1000Shake.png"
            alt="Logo 1000Shake"
            objectFit="contain"
            cursor="pointer"
            transition="all 0.3s ease"
            _hover={{ transform: "scale(1.05)" }}
            maxH={{ base: "35px", md: "50px" }}
          />
        </Link>
      </Box>

      {/* Liens au centre - visible uniquement sur desktop */}
      {!isMobile && (
        <Flex position="absolute" left="50%" transform="translateX(-50%)">
          <Link
            href="/"
            mx={3}
            color={COLORS.creamText}
            fontSize="lg"
            fontWeight="medium"
            transition="all 0.3s ease"
            _hover={{ textDecoration: "underline", color: "white" }}
          >
            {texts[language].home.title}
          </Link>
          <Link
            href="/machine"
            mx={3}
            color={COLORS.creamText}
            fontSize="lg"
            fontWeight="medium"
            transition="all 0.3s ease"
            _hover={{ textDecoration: "underline", color: "white" }}
          >
            {texts[language].machine.title}
          </Link>
          <Link
            href="/contact"
            mx={3}
            color={COLORS.creamText}
            fontSize="lg"
            fontWeight="medium"
            transition="all 0.3s ease"
            _hover={{ textDecoration: "underline", color: "white" }}
          >
            {texts[language].contact.title}
          </Link>
        </Flex>
      )}

      {/* Menu hamburger pour mobile */}
      {isMobile && (
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label="Menu"
            icon={<HamburgerIcon />}
            variant="ghost"
            color={COLORS.creamText}
            _hover={{ bg: `${COLORS.primary}20` }}
            _active={{ bg: `${COLORS.primary}30` }}
            size={{ base: "sm", md: "md" }}
          />
          <MenuList 
            bg={COLORS.background} 
            borderColor={COLORS.primary}
            minW="200px"
            zIndex={1000}
            ml="-75px"
          >
            <MenuItem 
              as={Link} 
              href="/"
              _hover={{ bg: `${COLORS.primary}20` }}
              color={COLORS.textPrimary}
              fontSize="md"
              py={3}
            >
              {texts[language].home.title}
            </MenuItem>
            <MenuItem 
              as={Link} 
              href="/machine"
              _hover={{ bg: `${COLORS.primary}20` }}
              color={COLORS.textPrimary}
              fontSize="md"
              py={3}
            >
              {texts[language].machine.title}
            </MenuItem>
            <MenuItem 
              as={Link} 
              href="/contact"
              _hover={{ bg: `${COLORS.primary}20` }}
              color={COLORS.textPrimary}
              fontSize="md"
              py={3}
            >
              {texts[language].contact.title}
            </MenuItem>
          </MenuList>
        </Menu>
      )}

      {/* Bouton langue à droite */}
      <Button
        onClick={toggleLanguage}
        bg="transparent"
        p={0}
        _hover={{ transform: "scale(1.05)" }}
        _active={{
          transform: "scale(0.95)",
          boxShadow: `0 0 0 6px ${COLORS.primary}33`,
          borderRadius: "full",
        }}
        transition="all 0.15s ease"
        minW="auto"
        position={isMobile ? "absolute" : "relative"}
        right={isMobile ? "4" : "auto"}
      >
        <Image
          src={language === "fr" ? flags.fr : flags.en}
          alt={language === "fr" ? "Drapeau français" : "British flag"}
          boxSize={{ base: "25px", md: "30px" }}
          objectFit="cover"
          borderRadius="full"
          filter="brightness(0.85)"
        />
      </Button>
    </Flex>
  );
};

export default Navbar;
